const langtrans={
      gywmm:["关于我们","About us"],
      xwzzx:["新闻中心","Press Center"],
      qqjylm:["全球救援联盟","Jiang Tai Global Assistance Service Alliance"],
      xssffw:["星使服务","Xingshi Serevice"],
      zzgqqy:["中国企业走出去全球救援服务论坛暨“一带一路”商机与对策于3月22日在六朝古都南京圆满召开","en_translated"],
      xwhpgg:["玄武湖畔各界嘉宾云集","en_translated"],
      zsjjjx:["钟山脚下共话全球救援","en_translated"],
      nyryjt:["年3月22日，由江泰国际合作联盟和江泰全球救援联盟共同主办的“2017全球救援服务论坛”在南京召开。","en_translated"],
      jtqqjy:["江泰全球救援联盟年会于南京成功召开","en_translated"],
      nyrxwy:["年3月20日下午，由江泰救援服务有限公司于去年3月发起成立的江泰全球救援联盟在风光迤逦","en_translated"],
      scktds:["沈开涛董事长拜访联合国世界旅游组织总部","en_translated"],
      xbyddd:["西班牙当地时间2016年7月7日上午，江泰保险经纪股份有限公司和江泰救援服务有限公司沈开涛董事长","en_translated"],
      ddjxyj:["大救星：“一键救援”改变中国人出行方式","en_translated"],
      gjgjjl:["国家旅游局数据显示，2015年中国公民出境1","en_translated"],
      yrcnjj:["亿人次，2016年将达到1","en_translated"],
      yrcyjn:["亿人次，预计2020年将达到5亿","en_translated"],
      jyjgdl:["救援机构登录成功","Your login Assistance organization is successful"],
      jjgjgd:["监管机构登录成功","en_translated"],
      zzzhzz:["指挥中心登录成功","en_translated"],
      dlsbgy:["登录失败，该用户不属于监管机构","en_translated"],
      dlsbyh:["登录失败，用户名或密码错误","Your login failed for incorrect user name or password"],
      dlsbwz:["登录失败，未知错误","Your login failed for unknown reason"],
}
export default langtrans;


// WEBPACK FOOTER //
// ./src/assets/languagejs/news.vue.trans.js